// initial state
import { RBAClient } from 'rba-client'
const client = RBAClient.getInstance(require('@/api/config'))

const state = {
  records: []
}

// getters
const getters = {
  risks: state => {
    return state.records
  }
}

// actions
const actions = {
  lists: () => {

  },
  get_risk_info: (unusedContext, payload) => {
    return client.screen.riskScreening(payload)
  },
  get_risk_assessment: (unusedContext, payload) => {
    return client.risk_assessment
      .findWhere(payload)
      .then(response => {
        response.data.map(async risk_assessment => {
          // fetch factors
          risk_assessment.factors = await client.risk_assessment_factor
            .findWhere({
              where: {
                id: {
                  $In: risk_assessment.factors.map(f => f.id)
                }
              }
            })
            .then(async response => {
              // fetch questions
              response.data.map(async factor => {
                factor.questions = await client.risk_assessment_question
                  .findWhere({
                    where: {
                      id: {
                        $In: factor.questions.map(q => q.id)
                      }
                    }
                  })
                  .then(question => {
                    return question.data
                  })
              })
              return response.data
            })
        })
        return response
      })
  },
  save_risk_assessment: (unusedContext, payload) => {
    // eslint-disable-next-line
    const dateStringToInt = (date_string) => {
      date_string = date_string || 0 // default to 0
      return typeof date_string === 'string' && date_string && !isNaN(new Date(date_string)) ? new Date(date_string).getTime() : date_string
    }
    const data = JSON.parse(JSON.stringify(payload))
    if (data.create_date) {
      data.create_date = dateStringToInt(data.create_date)
    }

    return client.risk_assessment_history
      .create(data)
      .then(response => {
        return response
      })
  }
}

// mutations
const mutations = {
  SET_RECORDS (state, payload) {
    state.records = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
